var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA9F82F8-79ED-4896-A211-7CA294EAC90D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -762.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(22.000000, 664.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,10.1580435 C15,8.29922495 13.9336221,6.64028799 12.3365125,5.83333333 C12.2869135,9.39737355 9.39737355,12.2869135 5.83333333,12.3365125 C6.64028799,13.9336221 8.29922495,15 10.1580435,15 C11.0295682,15 11.8770934,14.7678905 12.6217637,14.3268711 L14.9788576,14.9788576 L14.3268711,12.6217637 C14.7678905,11.8770934 15,11.0295682 15,10.1580435 L15,10.1580435 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4444444,5.72222222 C11.4444444,2.56692798 8.87751647,0 5.72222222,0 C2.56692798,0 0,2.56692798 0,5.72222222 C0,6.75054835 0.273717217,7.75177719 0.793482701,8.63078223 L0.0210375817,11.4232925 L2.81366221,10.6509617 C3.69266725,11.1707272 4.6938961,11.4444444 5.72222222,11.4444444 C8.87751647,11.4444444 11.4444444,8.87751647 11.4444444,5.72222222 Z M4.84413186,4.39045183 L3.96604149,4.39045183 C3.96604149,3.42203705 4.75380744,2.6342711 5.72222222,2.6342711 C6.690637,2.6342711 7.47840296,3.42203705 7.47840296,4.39045183 C7.47840296,4.88197664 7.27031383,5.35440755 6.90730121,5.68643547 L6.16126741,6.3692422 L6.16126741,7.05399261 L5.28317704,7.05399261 L5.28317704,5.98256229 L6.31447588,5.03861514 C6.49878339,4.86997148 6.60031259,4.63981577 6.60031259,4.39045183 C6.60031259,3.90624444 6.20642961,3.51236147 5.72222222,3.51236147 C5.23801483,3.51236147 4.84413186,3.90624444 4.84413186,4.39045183 Z M5.28317704,7.93208298 L6.16126741,7.93208298 L6.16126741,8.81017334 L5.28317704,8.81017334 L5.28317704,7.93208298 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.58fbeac7e5c903182531414757d80ba2.svg";
export { ForwardRef as ReactComponent };